export enum PropertyTypeSlug {
  House = "house-prices",
  Unit = "unit-prices",
}

export enum TextCase {
  Capitalised,
  Lowercase,
  Uppercase,
}
